<template>
    <div id="outer" class="edith-bg-light">
        <b-button :variant="buttonVariant('anfaelle')"
                  id="anfaelle-tab"
                  v-on:click="navigateToRoute('anfaelle')"
                  :disabled="$route.name==='anfaelle'">
            Anfallstypen
        </b-button>
        <b-button :variant="buttonVariant('technische-untersuchungen')"
                  id="tu-tab"
                  v-on:click="navigateToRoute('technische-untersuchungen')"
                  :disabled="$route.name==='technische-untersuchungen'">
            Technische Untersuchungen
        </b-button>
        <b-button :variant="buttonVariant('diagnose')"
                  id="diagnose-tab"
                  v-on:click="navigateToRoute('diagnose')"
                  :disabled="!diagnosestellungReachable || $route.name === 'diagnose'">
            Diagnose
        </b-button>
        <b-button :variant="buttonVariant('empfehlung')"
                  id="therapie-tab"
                  v-on:click="navigateToRoute('empfehlung')"
                  :disabled="!therapieReachable  || $route.name === 'empfehlung'">
            Therapie
        </b-button>
        <DeletionModal :show="deletionModalDisplayed"
                       :header-message="this.modalText[this.$route.name]"
                       :subheader-message="'Bisher gemachte Eintragungen werden nicht gespeichert.'"
                       :abort-button-label="'Erfassung fortsetzen'"
                       :confirm-button-label="'Abbrechen und Daten verwerfen'"
                       @close="closeDeletionModal"
                       @deleteConfirm="navigateToRouteWithoutSaving"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import DeletionModal from "../modal/DeletionModal";

export default {
    name: "TabComponent",
    components: {DeletionModal},
    data() {
        return {
            tabIndexByRouteName: {
                'anfaelle': 0,
                'technische-untersuchungen': 1,
                'diagnose': 2,
                'empfehlung': 3
            },
            deletionModalDisplayed: false,
            nextRouteName: undefined,
            modalText:{
                'anfaelle':'Anfallstyperfassung wirklich abbrechen?',
                'technische-untersuchungen':'Technische Untersuchungerfassung wirklich abbrechen?'
            }
        }
    },
    computed: {
        ...mapGetters('cdss', [
            'diagnosestellungReachable',
            'therapieReachable',
            'diagnosestellung',
            'showSavedData'
        ])
    },
    methods: {
        navigateToRoute(routeName) {
            if (routeName === 'diagnose') {
                if (!this.diagnosestellung.vorgeschlageneDiagnose) {
                    this.$store.commit('cdss/setShowNoDiagnoseFoundModal', true)
                }
            }
            // Prevent rerouting to the already active route
            if (this.$route.name !== routeName) {
                if (this.showSavedData) {
                    this.$router.push(routeName)
                } else {
                    this.showDeletionModal(routeName)
                }
            }
        },
        buttonVariant(routeName) {
            if (this.$route.name === routeName) {
                return 'info'
            } else {
                return 'secondary'
            }
        },
        showDeletionModal(routeName) {
            this.nextRouteName = routeName
            this.deletionModalDisplayed = true
        },
        closeDeletionModal() {
            this.deletionModalDisplayed = false
        },
        navigateToRouteWithoutSaving() {
            this.deletionModalDisplayed = false
            this.$store.commit('cdss/setShowSavedDataFlag', true)
            this.$router.push(this.nextRouteName)
        }
    }
}
</script>

<style scoped>

#outer {
    display: grid;
    grid-template-areas: "anfaelle tus diagnose therapie";
    grid-template-rows: var(--tab-height);
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 10px;
    background-color: white;
}

#anfaelle-tab {
    grid-area: anfaelle;
    align-self: center;
}

#tu-tab {
    grid-area: tus;
    align-self: center;
}

#diagnose-tab {
    grid-area: diagnose;
    align-self: center;
}

#therapie-tab {
    grid-area: therapie;
    align-self: center;
}
</style>
